import { HeaderAccountWrapper as HeaderAccount } from './HeaderAccountWrapper';

export default HeaderAccount;
